import React from 'react'
import { Minus, Plus } from 'lucide-react'

import { useTenant } from '@rewardops/auth'
import { cn } from '@rewardops/ui'

export const QuantitySelector = ({
  quantity,
  onQuantityChange,
  className,
}: {
  quantity: number
  onQuantityChange: (newQuantity: number) => void
  className?: string
}) => {
  const tenant = useTenant()
  const itemLimit = tenant?.itemQuantityLimit ?? 10

  const handleIncrement = () => {
    itemLimit > quantity && onQuantityChange(quantity + 1)
  }

  const handleDecrement = () => {
    onQuantityChange(Math.max(1, quantity - 1))
  }

  return (
    <div className={cn('flex items-center', className)}>
      <button
        id="decrement-item-quantity"
        onClick={handleDecrement}
        className="flex h-10 w-10 cursor-pointer select-none items-center justify-center rounded-s-lg border border-r-0 text-gray-500"
        aria-label="Decrement quantity"
      >
        <Minus className="m-2" />
      </button>
      <span
        id="item-quantity"
        className="flex h-10 flex-grow items-center justify-center border border-x-0 border-y text-center text-sm text-gray-900"
        aria-live="polite"
      >
        {quantity}
      </span>
      <button
        id="increment-item-quantity"
        onClick={handleIncrement}
        className="flex h-10 w-10 cursor-pointer select-none items-center justify-center rounded-e-lg border border-l-0 text-gray-500"
        aria-label="Increment quantity"
      >
        <Plus className="m-2" />
      </button>
    </div>
  )
}
